import { render, staticRenderFns } from "./footersSeventhNew.vue?vue&type=template&id=83cbed88&scoped=true"
import script from "./footersSeventhNew.vue?vue&type=script&lang=js"
export * from "./footersSeventhNew.vue?vue&type=script&lang=js"
import style0 from "./footersSeventhNew.vue?vue&type=style&index=0&id=83cbed88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cbed88",
  null
  
)

export default component.exports